// extracted by mini-css-extract-plugin
export var customSlider = "slider-module--customSlider--8278e";
export var headline = "slider-module--headline--71335";
export var headlineSubInfo = "slider-module--headlineSubInfo--022c9";
export var iconWrapper = "slider-module--iconWrapper--c3a1d";
export var infoToolTipContainer = "slider-module--infoToolTipContainer--79a22";
export var italicizedSubText = "slider-module--italicizedSubText--366f0";
export var label = "slider-module--label--48692";
export var light = "slider-module--light--e9611";
export var platformInfoToolTipContainer = "slider-module--platformInfoToolTipContainer--f1d66";
export var platformRange = "slider-module--platformRange--9d875";
export var platformRangeLabelContainer = "slider-module--platformRangeLabelContainer--32f0e";
export var platformSubText = "slider-module--platformSubText--5e081";
export var platformSubTextContainer = "slider-module--platformSubTextContainer--e508d";
export var rangeLabel = "slider-module--rangeLabel--a0e45";
export var rangeLabelContainer = "slider-module--rangeLabelContainer--2dace";
export var rangeLabelList = "slider-module--rangeLabelList--a586f";
export var slider = "slider-module--slider--4fbaa";
export var subText = "slider-module--subText--7453d";
export var subTextContainer = "slider-module--subTextContainer--ee73b";
export var subTextInfo = "slider-module--subTextInfo--eed53";
export var subTextInfoHeader = "slider-module--subTextInfoHeader--09602";
export var tooltipContent = "slider-module--tooltipContent--aab59";